// Système de logging configurable pour production
const logger = {
  debug: (message, ...args) => {
    if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true') {
    }
  },
  
  info: (message, ...args) => {
  },
  
  warn: (message, ...args) => {
  },
  
  error: (message, ...args) => {
    console.error(`❌ [ERROR] ${message}`, ...args);
  },
  
  success: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
    }
  }
};

export default logger;